import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore, useCatStore } from '../../stores';
import { PawLogo } from '../shared/PawLogo';

export const Header: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const currentCat = useCatStore((state) => state.currentCat);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 glass-bar z-40">
      <div className="px-4 py-3 md:px-8">
        <div className="flex items-center justify-between md:justify-start md:gap-8">
          {/* Mobile: Logo + Title */}
          <div className="flex items-center gap-2.5 md:hidden flex-1 justify-center">
            <div className="w-7 h-7 bg-sage-600 rounded-lg flex items-center justify-center shadow-xs">
              <PawLogo className="w-4 h-4" color="white" faceColor="#6D28A8" />
            </div>
            <span className="text-base font-bold text-charcoal">{t('app.name')}</span>
          </div>

          {/* Desktop: Logo + Title */}
          <div className="hidden md:flex items-center gap-2.5">
            <div className="w-8 h-8 bg-sage-600 rounded-lg flex items-center justify-center shadow-xs">
              <PawLogo className="w-4.5 h-4.5" color="white" faceColor="#6D28A8" />
            </div>
            <span className="text-lg font-bold text-charcoal">{t('app.name')}</span>
          </div>

          {/* Center: Current Cat Name (Desktop Only) */}
          <div className="hidden md:block flex-1 text-center">
            {currentCat && (
              <p className="text-mid font-medium text-sm">{currentCat.name}</p>
            )}
          </div>

          {/* Right: Cat Name (Mobile) + Logout Button (All) */}
          <div className="flex items-center gap-3">
            <div className="md:hidden text-right">
              {currentCat && (
                <p className="text-xs text-soft font-medium">{currentCat.name}</p>
              )}
            </div>

            <button
              onClick={handleLogout}
              className="px-3 py-1.5 rounded-lg text-soft hover:text-charcoal hover:bg-sage-50 transition-all duration-200 font-medium text-sm"
              title={t('nav.header.logoutTitle')}
            >
              <span className="hidden sm:inline">{t('nav.header.logOut')}</span>
              <svg className="w-4 h-4 sm:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
